<template>

<div class="bar-right" v-click-outside="onOutsideClick">

	<template v-if="!$isMobile">

		<slot></slot>

	</template>

	<core-button v-if="$isMobile" v-on:click="onToggleClick" theme="filter" :icon="(is.expanded) ? 'remove' : 'ellipsis-v'" :iconOnly="true" class="bar-right-toggle" />
	
	<div class="bar-right-expand" :class="{'is-active': is.expanded}" v-if="$isMobile">

		<slot></slot>

	</div>

</div>

</template>

<script>

import vClickOutside from 'v-click-outside'

export default {

	directives: {
		clickOutside: vClickOutside.directive
	},

	data: function() {

		return {
			is: {
				expanded: false
			}
		}

	},

	methods: {

		onToggleClick: function() {

			this.is.expanded = !this.is.expanded

		},

		onOutsideClick: function() {

			this.is.expanded = false

		}

	}

}

</script>

<style scoped>

.bar-right {
	display: flex;
	justify-content: flex-end;
	flex-shrink: 0;
	height: 40px;
	padding: 12px 20px;
}

.is-smaller .bar-right {
	padding: 12px 20px;
}

.is-tablet .bar-right {
	padding: 12px 10px;
}

.is-mobile .bar-right {
	padding: 4px 0px;
}

.bar-right-toggle {
	z-index: 3;
}

.bar-right-dropdown,
.bar-right-expand {
	position: fixed;
	z-index: 1;
    right: -240px;
    top: 0px;
    background-color: #fff;
	width: 200px;
    bottom: 0px;
    box-shadow: 0 7px 29px 0 rgba(100, 100, 111, .2);
	transition: right 100ms linear;
	padding: 50px 0px 0px 0px;
	overflow: auto;
	user-select: none;
}

.bar-right-dropdown {
	z-index: 2;
}

.bar-right-dropdown.is-active,
.bar-right-expand.is-active {
	right: 0px;
}

.bar-right-expand >>> .theme-filter {
	width: 100%!important;
	max-width: 100%!important;
	box-shadow: none;
	background-color: #fff;
	border-bottom: 1px solid #eee;
	border-radius: 0px!important;
	height: 40px!important;
	line-height: 40px!important;
	margin: 0px!important;
}

#app.is-mobile:not(.is-listing) .bar.has-scrolled .bar-right-toggle {
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}

</style>
